import React, { useState } from 'react'
import { Box, Typography, Divider, Badge, Tooltip, TextField } from '@mui/material'
import { StaticDatePicker, LocalizationProvider, PickersDay } from '@mui/lab'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import {
  publicHoliday2022,
  publicHoliday2023,
  publicHoliday2024,
  publicHoliday2025,
  publicHoliday2026,
} from '../../constant/ph'

function getRandomNumber(min, max) {
  return Math.round(Math.random() * (max - min) + min)
}

export const CalendarCard = () => {
  const [selectedDays, setSelectedDays] = useState([1, 2, 15])
  const [selectedDate, handleDateChange] = useState(new Date())

  const handleMonthChange = async () => {
    // just select random days to simulate server side based data
    return new Promise((resolve) => {
      setTimeout(() => {
        setSelectedDays([1, 2, 3].map(() => getRandomNumber(1, 28)))
        resolve()
      }, 1000)
    })
  }

  return (
    <Box
      backgroundColor='#fff'
      borderRadius={3}
      width='100%'
      height='100%'
      display='flex'
      alignItems='center'
      justifyContent='center'
    >
      <Box display='flex' justifyContent='center' flexDirection='column' alignItems='center' pt={5}>
        <Typography variant='h6'>Calendar</Typography>

        <Divider />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <StaticDatePicker
            displayStaticWrapperAs='desktop'
            openTo='day'
            // value={value}
            // onChange={(newValue) => {
            //   setValue(newValue)
            // }}
            renderInput={(params) => <TextField {...params} />}
            // showTodayButton={true}
            value={selectedDate}
            onChange={handleDateChange}
            onMonthChange={handleMonthChange}
            minDate={new Date(2022, 0, 1)}
            maxDate={new Date(new Date().getFullYear() + 1, 11, 31)}
            renderDay={(day, _value, DayComponentProps) => {
              const publicHolidayArr = Object.values({
                ...publicHoliday2022,
                ...publicHoliday2023,
                ...publicHoliday2024,
                ...publicHoliday2025,
                ...publicHoliday2026,
              })
              let holidayObj = null

              for (let i = 0; i < publicHolidayArr.length; i++) {
                const eachPb = publicHolidayArr[i]
                const currentMs = day.getTime()

                const holidayStartMs = new Date(eachPb.startDate).getTime()
                const holidayEndMs = new Date(eachPb.endDate).getTime()

                const isDateBetween = currentMs >= holidayStartMs && currentMs <= holidayEndMs

                holidayObj = isDateBetween ? eachPb : null
                if (holidayObj) break
              }

              const isHoliday = Boolean(holidayObj)

              return (
                <Tooltip
                  placement='top'
                  title={holidayObj?.label || ''}
                  open={isHoliday ? undefined : false}
                  enterTouchDelay={0}
                  key={day.toString()}
                >
                  <Badge
                    overlap='circular'
                    variant='dot'
                    badgeContent={isHoliday ? ' ' : undefined}
                    color='holiday'
                    invisible={!isHoliday}
                    sx={{ color: '#FF0000' }}
                  >
                    <PickersDay {...DayComponentProps} />
                  </Badge>
                </Tooltip>
              )
            }}
          />
        </LocalizationProvider>
      </Box>
    </Box>
  )
}
